import request from "@/utils/request";

/**
 * 查询联系我们详情
 */
export function getContactUsDetails() {
  return request({
    url: "/contactUsBase/detail",
    method: "get",
  });
}

/**
 * 招聘信息分页
 */
export function getHireList(data: any) {
  return request({
    url: "/contactUsRecruit/pageList",
    method: "post",
    data,
  });
}

/**
 * 查询公司基础信息
 */
export function getPortalBaseInfo(params = {}) {
  return request({
    url: "/portalBaseInfo/getPortalBaseInfo",
    method: "get",
    params,
  });
}
